



























































































































































































































import Vue from 'vue';
import { Component, Model } from 'vue-property-decorator';
import { Base } from '@/components/common/base';
import { PaginationModel, VAction, VHeaders } from '@/models/pagedlistmodel';
import { callHistoryService, userService, conversationService } from '@/shared';
import { DateTimeHelper as _dateTime } from '@/helper/date-time.helper';
import { mask } from 'vue-the-mask';
import { Utils } from '@/helper/utils';
import {
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from '@microsoft/signalr';
import { AudioStreamList, TranscriptionList } from '@/models/telephony/audioStream';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    liveCallRating: {
      get() {
        if (this.rating) {
          const score = this.rating;
          if (score == 0) {
            return 'Very Poor';
          } else if (score == 0.5) {
            return 'Very Poor';
          } else if (score == 1) {
            return 'Poor';
          } else if (score == 1.5) {
            return 'Poor';
          } else if (score == 2) {
            return 'Average';
          } else if (score == 2.5) {
            return 'Average';
          } else if (score == 3) {
            return 'Average';
          } else if (score == 3.5) {
            return 'Good';
          } else if (score == 4) {
            return 'Good';
          } else if (score == 4.5) {
            return 'Excellent';
          } else if (score == 5) {
            return 'Excellent';
          } else {
            return 'N/A';
          }
        }
      },
      set(val) {
        // computed
      },
    },
  },
  directives: {
    mask,
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    Calendar: () => import('@/components/common/app.calendar.vue'),
  },
})
export default class LiveInboundCallsListPage extends Base {
  public pagination = new PaginationModel('createdAt');
  public recentCallsPagination = new PaginationModel('createdAt');
  public phoneMask: string = '(###)###-#####';
  public loading: boolean = false;
  public recentCallsRecordingLoading: boolean = false;
  public recentCallsLoading: boolean = false;
  public customerInfoLoader: boolean = false;
  public isPlaying: boolean = false;
  public rating: number = 0;
  public myAudioPlayer: any;
  public updateTime: boolean = true;

  public streamingText: string = '';

  public actions: VAction[] = [];
  public recentCallsActions: VAction[] = [];
  public headers: VHeaders[] = [];
  public recentCallHeaders: VHeaders[] = [];
  public searchByNumber: string = '';
  public showSendEmailPopup: boolean = false;
  public emailLoader = false;
  public showTextPopup: boolean = false;
  public isCallUpdate: boolean = false;
  public searchOnDms: boolean = false;
  public playRecording: boolean = false;
  public recentCallsRecording: boolean = false;
  public showRecordingPopup: boolean = false;
  public streamId: string = '';
  public activeCalls: any[] = [];
  public recentCalls: any[] = [];
  public userStores: any[] = [];
  public customerDetails = {};
  public src: string = '';
  public recentTranscription: any[] = [];

  public textToNumber: string = '';
  public selectedStore: string = '';
  public selectedStoreId: number = 0;
  public data1 = [];
  public audioList: AudioStreamList[] = [];
  public transcriptionList: TranscriptionList[] = [];
  public arrayOfAudio = [];
  public arrayOfOutboundAudio = [];

  public arrayOfTranscription = [];
  public currentStoreId: number = 0;
  public inboundChunkIsPlaying: boolean;
  public isOutboundChunkIsPlaying: boolean;
  public connection: HubConnection;
  public sentimentText: string;
  public callSid: string = '';
  public currentTime: number = 0;
  public recordedAt: any = new Date();
  public customerInfoFromNumber: string = '';

  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'liveInBoundCall');

    this.setActions();
    this.setHeaders();
    this.getUserStores();
    this.getAllLiveCall();
    this.getRecentCall();
    this.currentStoreId = this.userSession.storeId;
    window.AudioContext = window.AudioContext; // || window.webkitAudioContext || window.mozAudioContext;

    this.connection = new HubConnectionBuilder()
      .withUrl(Utils.API_WEB_HUB_URL)
      .configureLogging(LogLevel.Information)
      .build();

    this.connection.serverTimeoutInMilliseconds = 100000;

    const vm = this;

    this.connection.on('LiveCallListNotification', function (message) {
      vm.getUpdatedLiveCall(message);
    });
    this.connection.on('LiveSentiments_' + this.currentStoreId, function (
      message
    ) {
      const liveCall = vm.activeCalls.filter(
        (x) => x.streamId == message.streamId
      )[0];
      if (liveCall) {
        vm.activeCalls = vm.activeCalls.filter(
          (x) => x.streamId != message.streamId
        );
        liveCall.sentiments = message.sentiments;
        vm.activeCalls.push(liveCall);
        vm.pagination.totalItems = vm.activeCalls.length;
        if (vm.streamId == message.streamId) {
          vm.GetCustomerSentiment(vm, parseFloat(liveCall.sentiments));
        }
      }
    });

    this.connection.on('RemoveCall', function (message) {
      vm.removeLiveCall(message);
    });

    this.connection
      .start()
      .then(function () {
        console.log('Connected!');
      })
      .catch(function (err) {
        console.log('SignalR Connection Error: ', err);
      });

    this.connection.onclose(() => {
      console.log('Connection disconnected');
      setTimeout(startSignalRConnection(this.connection), 1000);
    });

    const startSignalRConnection = (connection) =>
      connection
        .start()
        .then(() => console.info('Websocket Connection ReEstablished'))
        .catch(function (err) {
          console.log('SignalR Connection Error: ', err);
        });
  }

  public StreamText(vm, callSid) {
    this.connection.on('LiveStreamText_' + callSid, function (message) {
      console.log(
        'Text----- ' + message.callDirection,
        message.transcriptionText
      );
      if (message.streamId == vm.streamId) {
        vm.startTranscription(
          message.transcriptionText,
          message.streamId,
          message.callDirection
        );
      }
    });
  }

  public GetCustomerSentiment(vm, sentimentScore) {
    console.log('Rating ', sentimentScore);
    const score = sentimentScore * 10;
    switch (true) {
      case score <= -9:
        vm.rating = 0;
        break;
      case score <= -8 && score <= -7:
        vm.rating = 0.5;
        break;
      case score <= -6 && score <= -5:
        vm.rating = 1;
        break;
      case score <= -4 && score <= -3:
        vm.rating = 1.5;
        break;
      case score <= -2 && score <= -1:
        vm.rating = 2;
        break;
      case score <= 0 && score <= 1:
        vm.rating = 2.5;
        break;
      case score <= 2 && score <= 3:
        vm.rating = 3;
        break;
      case score <= 4 && score <= 5:
        vm.rating = 3.5;
        break;
      case score <= 6 && score <= 7:
        vm.rating = 4;
        break;
      case score <= 8 && score <= 9:
        vm.rating = 4.5;
        break;
      case score <= 10:
        vm.rating = 5;
        break;
    }
  }

  // public UpdateCustomerSentiment(vm, callSid) {
  //   this.connection.on('UpdateCustomerSentiment_' + callSid, function(
  //     response
  //   ) {
  //     console.log('UpdateRating ', response);
  //     vm.updateScore(response);
  //   });
  // }

  public LiveAudioStream(vm, callSid) {
    this.connection.on('LiveAudioStream_' + callSid, function (message) {
      if (message.streamId == vm.streamId && message.transcriptionText != '') {
        console.error('message.transcriptionText ' + message.transcriptionText);
        vm.startTranscription(
          message.transcriptionText,
          message.streamId,
          message.track
        );
      }
      vm.startAudio(
        message.audioStream,
        message.streamId,
        message.track,
        message.transcriptionText
      );
    });
  }

  public async getCustomerDeatils(fromNumber: string) {
    try {
      let customerNumber = '';
      if (fromNumber != null) {
        customerNumber = fromNumber;
        this.customerInfoFromNumber = fromNumber;
      }
      this.searchOnDms = true;
      this.customerInfoLoader = true;

      const response = await callHistoryService.getCallCustomerDeatils(
        customerNumber,
        this.selectedStoreId
      );
      this.customerDetails = response;
      customerNumber = '';
    } finally {
      this.customerInfoLoader = false;
      this.searchOnDms = true;
    }
  }

  public showPopup(streamId, sentiments) {
    this.playRecording = true;
    this.isPlaying = false;
    this.streamingText = '';
    this.rating = 0;
    this.streamId = streamId;
    const vm = this;
    this.GetCustomerSentiment(vm, parseFloat(sentiments || '0'));
  }

  public showTranscriptionPopup(streamId) {
    this.streamingText = '';
    this.rating = 0;
    this.streamId = streamId;
  }

  public setHeaders(): void {
    this.headers = [
      {
        align: 'left',
        sortable: true,
        text: this.$parent.$t('callInbound.dateTime') as string,
        value: `createdAt`,
        fieldType: 'date',
      },
      {
        align: 'left',
        sortable: false,
        text: 'Customer Name',
        value: 'customerName',
      },
      {
        align: 'left',
        sortable: false,
        text: 'DealerShip Name',
        value: 'dealerShipName',
      },
      {
        align: 'left',
        sortable: false,
        text: 'To Number',
        value: 'toNumber',
      },
      {
        align: 'left',
        sortable: false,
        text: 'From Number',
        value: 'fromNumber',
      },
      {
        align: 'left',
        sortable: false,
        text: this.$parent.$t('callInbound.sentiment') as string,
        value: 'sentiments',
        fieldType: 'template',
        template: (item) => {
          const score = item.sentiments * 10;
          const rating = -10;
          if (score <= -9) {
            // rating = 0;
            return `<span> ${'Very Poor'} </span>`;
          } else if (score <= -8 && score <= -7) {
            // rating = 0.5;
            return `<span> ${'Very Poor'} </span>`;
          } else if (score <= -6 && score <= -5) {
            // rating = 1;
            return `<span> ${'Poor'} </span>`;
          } else if (score <= -4 && score <= -3) {
            // rating = 1.5;
            return `<span> ${'Poor'} </span>`;
          } else if (score <= -2 && score <= -1) {
            // rating = 2;
            return `<span> ${'Average'} </span>`;
          } else if (score <= 0 && score <= 1) {
            //  rating = 2.5;
            return `<span> ${'Average'} </span>`;
          } else if (score <= 2 && score <= 3) {
            // rating = 3;
            return `<span> ${'Average'} </span>`;
          } else if (score <= 4 && score <= 5) {
            // rating = 3.5;
            return `<span> ${'Good'} </span>`;
          } else if (score <= 6 && score <= 7) {
            // rating = 4;
            return `<span> ${'Good'} </span>`;
          } else if (score <= 8 && score <= 9) {
            // rating = 4.5;
            return `<span> ${'Excellent'} </span>`;
          } else if (score <= 10) {
            // rating = 5;
            return `<span> ${'Excellent'} </span>`;
          } else {
            return `<span> ${'N/A'} </span>`;
          }
        },
      },
      // {
      //   align: 'left',
      //   sortable: false,
      //   text: this.$parent.$t('callInbound.listen') as string,
      //   value: 'listen',
      // },
      {
        align: 'center',
        isNotDataProp: true,
        text: 'Action',
        sortable: false,
      },
    ];

    this.recentCallHeaders = [
      {
        align: 'left',
        sortable: false,
        text: this.$parent.$t('callInbound.dateTime') as string,
        value: `createdAt`,
        fieldType: 'date',
      },
      {
        align: 'left',
        sortable: false,
        text: 'Customer Name',
        value: 'customerName',
      },
      {
        align: 'left',
        sortable: false,
        text: 'To Number',
        value: 'to',
      },
      {
        align: 'left',
        sortable: false,
        text: 'From Number',
        value: 'from',
      },
      {
        align: 'left',
        sortable: false,
        text: this.$parent.$t('callInbound.sentiment') as string,
        value: `score`,
        fieldType: 'template',
        template: (item) => {
          const score = item.score * 10;
          const rating = -10;
          if (score <= -9) {
            // rating = 0;
            return `<span> ${'Very Poor'} </span>`;
          } else if (score <= -8 && score <= -7) {
            // rating = 0.5;
            return `<span> ${'Very Poor'} </span>`;
          } else if (score <= -6 && score <= -5) {
            // rating = 1;
            return `<span> ${'Poor'} </span>`;
          } else if (score <= -4 && score <= -3) {
            // rating = 1.5;
            return `<span> ${'Poor'} </span>`;
          } else if (score <= -2 && score <= -1) {
            // rating = 2;
            return `<span> ${'Average'} </span>`;
          } else if (score <= 0 && score <= 1) {
            //  rating = 2.5;
            return `<span> ${'Average'} </span>`;
          } else if (score <= 2 && score <= 3) {
            // rating = 3;
            return `<span> ${'Average'} </span>`;
          } else if (score <= 4 && score <= 5) {
            // rating = 3.5;
            return `<span> ${'Good'} </span>`;
          } else if (score <= 6 && score <= 7) {
            // rating = 4;
            return `<span> ${'Good'} </span>`;
          } else if (score <= 8 && score <= 9) {
            // rating = 4.5;
            return `<span> ${'Excellent'} </span>`;
          } else if (score <= 10) {
            // rating = 5;
            return `<span> ${'Excellent'} </span>`;
          }
          // }
        },
      },
      {
        align: 'center',
        isNotDataProp: true,
        text: 'Action',
        sortable: false,
      },
    ];
  }

  public setActions(): void {
    this.actions = [
      {
        type: 'button',
        icon: 'fa fa-play-circle',
        title: 'Play Recording',
        action: (model: any) => {
          this.showPopup(model.streamId, model.sentiments);
        },
      },
      {
        type: 'button',
        icon: 'far fa-user-circle',
        title: 'Customer Info',
        action: (model: any) => {
          this.getCustomerDeatils(model.fromNumber);
        },
      },
    ];

    this.recentCallsActions = [
      {
        type: 'button',
        icon: 'fa fa-play-circle',
        title: 'Play Recording',
        action: (model: any) => {
          this.viewVoiceAttachment(model);
        },
      },
      {
        type: 'button',
        icon: 'far fa-user-circle',
        title: 'Customer Info',
        action: (model: any) => {
          this.getCustomerDeatils(model.from);
        },
      },
    ];
  }

  public async getRecentCall(): Promise<void> {
    try {
      this.recentCallsLoading = true;
      this.$emit('update:progress', this.recentCallsLoading);
      const response = await callHistoryService.getRecentCall(
        this.recentCallsPagination
      );
      this.recentCalls = response.results;
      this.recentCallsPagination.totalItems = response.total;
    } finally {
      this.recentCallsLoading = false;
      this.$emit('update:progress', this.recentCallsLoading);
    }
  }

  public async getAllLiveCall(): Promise<void> {
    try {
      this.loading = true;
      this.$emit('update:progress', this.loading);
      const response = await callHistoryService.getAllLiveCalls();
      for (let index = 0; index < response.length; index++) {
        const element = response[index];
        this.getUpdatedLiveCall(element);
      }
      this.pagination.totalItems = response.length;
    } finally {
      this.loading = false;
      this.$emit('update:progress', this.loading);
    }
  }

  public async getUpdatedLiveCall(data): Promise<void> {
    try {
      this.loading = true;
      this.$emit('update:progress', this.loading);
      // this.StreamText(this, data.callSid);
      this.GetCustomerSentiment(this, parseFloat(data.sentiments || '0'));
      // this.UpdateCustomerSentiment(this, data.callSid);
      this.LiveAudioStream(this, data.callSid);

      const liveCall = this.activeCalls.filter(
        (x) => x.streamId == data.streamId
      );

      if (liveCall.length == 0 && this.currentStoreId == data.storeId) {
        this.activeCalls.push({
          tenantId: data.tenantId,
          enterpriseId: data.enterpriseId,
          storeId: data.storeId,
          streamId: data.streamId,
          sentiments: data.sentiments,
          fromNumber: data.fromNumber,
          toNumber: data.toNumber,
          createdAt: data.createdAt,
          customerName: data.customerName,
          dealerShipName: data.dealerShipName,
        });
      }

      this.pagination.totalItems = this.activeCalls.length;
    } finally {
      this.loading = false;
      this.$emit('update:progress', this.loading);
    }
  }

  public async removeLiveCall(data): Promise<void> {
    try {
      this.loading = true;
      if (this.streamId == data) {
        this.isPlaying = false;
        this.playRecording = false;
        this.stopRecording();
        this.sentimentText = '';
        this.searchOnDms = false;
      }
      this.$emit('update:progress', this.loading);

      const vm = this;
      this.audioList = vm.audioList.filter((x) => x.streamId != data);
      const liveCall = this.activeCalls.filter((x) => x.streamId != data);

      this.activeCalls = liveCall;
      this.pagination.totalItems = this.activeCalls.length;

      // Get final text sentiment
      // var finalStream = vm.transcriptionList.filter((x) => x.streamId == data);
      // console.log("finalStream " + finalStream);

      // if (finalStream.length > 0) {
      //   var finalText = finalStream.map((x) => x.transcriptionText).join(" ");

      //   vm.connection.invoke(
      //     "getCustomerFinalSentiment",
      //     finalText,
      //     finalStream[0].streamId,
      //     vm.currentStoreId,
      //     finalStream[0].callSid
      //   );
      //   this.transcriptionList = vm.transcriptionList.filter(
      //     (x) => x.streamId != data
      //   );
      // }
    } finally {
      this.loading = false;
      this.$emit('update:progress', this.loading);
    }
  }

  // public async updateScore(req): Promise<void> {
  //   try {
  //     console.log('updateScore', req);
  //     await conversationService.updateCallScore(
  //       req.callSid,
  //       req.sentimentScore
  //     );
  //   } catch {}
  // }

  public async viewVoiceAttachment(model: any) {
    const uri = Utils.API_BASE_URL + '/attachment/view/voice/' + model.recordingSid;
    // var response = await conversationService.ViewVoiceAttachmentUrl(recordingId);
    // const uri = Utils.API_BASE_URL + '/messages/getCallRecording/' + recordingId;
    // this.src = response;
    this.src = uri;
    this.recordedAt = model.createdAt;
    this.recentTranscription = model.callTranscription;
    this.recentCallsRecording = true;
  }

  public stopRecentCallRecording() {
    this.src = '';
    this.$refs.audio['currentTime'] = 0;
    this.currentTime = 0;
    this.recentCallsRecording = false;
  }

  public stopRecording() {
    this.audioList = this.audioList.filter((x) => x.streamId != this.streamId);
    this.src = '';
    this.streamId = '';
    this.playRecording = false;
    this.isPlaying = false;
    this.arrayOfTranscription = [];
    this.sentimentText = '';
  }

  public playLiveAudio() {
    this.isPlaying = !this.isPlaying;

    if (this.isPlaying) {
      const vm = this;
      let isStarted = false;
      setInterval((x) => {
        // tslint:disable: no-shadowed-variable
        if (
          vm.audioList.filter(
            (x) => x.streamId == vm.streamId && x.track == 'inbound'
          ).length < 2
        ) {
          return;
        }
        if (!isStarted) {
          isStarted = true;
          vm.liveOutBoundAudio();
          vm.liveAudio();
        }
      }, 1000);
    }
  }

  //   public playLiveTranscription(transcriptionText, streamId, track) {
  //     if (transcriptionText != "")
  //     {
  //       this.startTranscription(transcriptionText, streamId, track);
  //     }

  // //Sentiments
  //     // if (
  //     //   track == "inbound" &&
  //     //   transcriptionText != undefined &&
  //     //   transcriptionText != ""
  //     // ) {
  //     //   this.sentimentText += " " + transcriptionText;
  //     //   var that = this;
  //     //   this.connection.invoke(
  //     //     "getCustomerSentiment",
  //     //     that.sentimentText,
  //     //     streamId,
  //     //     that.currentStoreId,
  //     //     null
  //     //   );
  //     // }
  //   }

  public liveAudio() {
    if (this.isPlaying) {
      const vm = this;
      const chunkToPlay = vm.audioList.filter(
        (x) => x.streamId == vm.streamId && x.track == 'inbound'
      )[0];
      if (chunkToPlay && !vm.inboundChunkIsPlaying) {
        vm.inboundChunkIsPlaying = true;
        // if (chunkToPlay.transcriptionText)
        // {
        // console.log('chunkText:',chunkToPlay.transcriptionText);
        //   //Play Trancription
        //   vm.playLiveTranscription(
        //     chunkToPlay.transcriptionText,
        //     chunkToPlay.streamId,
        //     chunkToPlay.track
        //   );

        // }

        const context = new AudioContext();
        const source = context.createBufferSource();
        const blob = new Blob(
          [new Uint8Array(JSON.parse('[' + chunkToPlay.audioStream + ']'))],
          {
            type: 'audio/wav',
          }
        );
        blob.arrayBuffer().then((x) => {
          context.decodeAudioData(
            x,
            function (buffer) {
              source.buffer = buffer;
            },
            null
          );

          source.connect(context.destination);
          source.onended = function () {
            vm.audioList.splice(vm.audioList.indexOf(chunkToPlay), 1);
            vm.inboundChunkIsPlaying = false;
            vm.liveAudio();
          };
          // now play the sound.
          source.start(0);
        });
      } else {
        setTimeout(() => {
          vm.liveAudio();
        }, 500);
      }
    }
  }

  public liveOutBoundAudio() {
    if (this.isPlaying) {
      const vm = this;
      const chunkToPlay = vm.audioList.filter(
        (x) => x.streamId == vm.streamId && x.track == 'outbound'
      )[0];
      if (chunkToPlay && !vm.isOutboundChunkIsPlaying) {
        vm.isOutboundChunkIsPlaying = true;

        // if (chunkToPlay.transcriptionText)
        // {
        //   //Play Trancription
        //   vm.playLiveTranscription(
        //     chunkToPlay.transcriptionText,
        //     chunkToPlay.streamId,
        //     chunkToPlay.track
        //   );
        // }

        const context = new AudioContext();
        const source = context.createBufferSource();
        const blob = new Blob(
          [new Uint8Array(JSON.parse('[' + chunkToPlay.audioStream + ']'))],
          {
            type: 'audio/wav',
          }
        );
        blob.arrayBuffer().then((x) => {
          context.decodeAudioData(
            x,
            function (buffer) {
              source.buffer = buffer;
            },
            null
          );

          source.connect(context.destination);
          source.onended = function () {
            vm.audioList.splice(vm.audioList.indexOf(chunkToPlay), 1);
            vm.isOutboundChunkIsPlaying = false;
            vm.liveOutBoundAudio();
          };
          // now play the sound.
          source.start(0);
        });
      } else {
        setTimeout(() => {
          vm.liveOutBoundAudio();
        }, 500);
      }
    }
  }

  public startAudio(bytes, streamId, track, text) {
    if (this.streamId == streamId) {
      this.audioList.push({
        streamId,
        audioStream: bytes,
        track,
        transcriptionText: text
      });
    }
  }

  public startTranscription(text, streamId, callDirection) {
    // if (this.streamId && this.streamId == streamId && this.isPlaying) {
    this.streamingText += '\n' + text;
    this.arrayOfTranscription.push({
      text,
      streamId,
      callDirection,
      receivedAt: new Date(),
    });
    if (this.arrayOfTranscription.length > 6) {
      this.arrayOfTranscription.shift();
    }
    // } else {
    //   this.arrayOfTranscription = [];
    //   this.streamingText = '';
    // }
  }

  public updatePaging(paging: PaginationModel): void {
    this.pagination = paging;
  }

  public UpdateRecentCallPaging(paging: PaginationModel): void {
    this.recentCallsPagination = paging;
    this.getRecentCall();
  }

  public search(): void {
    this.pagination.page = 1;
  }

  public SkipForwardRecording(event) {
    const audio = this.$refs.audio['currentTime'];
    this.currentTime = audio + 6;
  }

  public SkipBackwardRecording() {
    const audio = this.$refs.audio['currentTime'];
    this.currentTime = audio - 6;
  }

  public getCustomerDeatilsById(event) {
    const data = this.userStores.filter((x) => x.storeName == event)[0];
    this.selectedStoreId = data.storeId;
    this.selectedStore = data.storeName;
    this.getCustomerDeatils(this.customerInfoFromNumber);
  }

  public async getUserStores() {
    const response = await userService.GetUserDetailsByUserId(
      this.userSession.sessionUserId
    );
    this.userStores = response.userStores;
    if (this.userStores != null) {
      const data = this.userStores.filter(
        (x) => x.storeId == this.userSession.storeId
      )[0];
      this.selectedStore = data.storeName;
      this.selectedStoreId = data.storeId;
    }
  }

  public closeSearchOnDms() {
    this.searchOnDms = false;
    this.customerDetails = {};
    this.customerInfoFromNumber = '';
  }
}
